import * as React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CloseLightRegular from './close-light-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CloseLightRegular {...validProps} />;
}
SvgComponent.iconName = 'closeLightRegular';

export const CloseLightRegularIcon = svgIconWrapper(SvgComponent);
